module.exports = __webpack_public_path__ + "042bf519e4938c366455f440b1e72c77.fbx";